import ValidatableProps from "../../validatable/documentation/ValidatableDocumentedProps";
import LabeledProps from "../../label/documentation/LabeledDocumentedProps";

const documentedProperties = [].concat(ValidatableProps, LabeledProps, [
    {
        name: "extraClasses",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "String to be append at the end of the class for the div wrapping the input."
    },
    {
        name: "value",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "The value to be seen in the input"
    },
    {
        name: "maxCharacters",
        type: "Number",
        defaultValue: "n/a",
        isRequired: "infinite",
        description:
            "Defines max characters for the input. In case the input becomes larger than this number, the last characters will be truncated to fit maxCharacters restriction."
    },
    {
        name: "placeholder",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Input's element placeholder as in HTML"
    },
    {
        name: "password",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If set to true set's input type to password."
    },
    {
        name: "onKeyPress",
        type: "Function",
        defaultValue: "n/a",
        isRequired: "false",
        description: "A callback function to be invoked when a key is pressed inside the input."
    },
    {
        name: "onChange",
        type: "Function",
        defaultValue: "n/a",
        isRequired: "false",
        description: "A callback function to be invoked when the input value is being changed."
    },
    {
        name: "preventInvalidInput",
        type: "Boolean",
        defaultValue: "n/a",
        isRequired: "false",
        description:
            "If set to true will make the Input to prevent invalid inputs instead of using standard validation notifications."
    },
    {
        name: "validateOnChange",
        type: "Boolean",
        defaultValue: "n/a",
        isRequired: "false",
        description:
            "If set to true, Input's validations will be done on change instead of on blur."
    },
    {
        name: "locales",
        type: "Array",
        defaultValue: "['english-uk']",
        isRequired: "false",
        description:
            "Considered only with alphanumeric or alpha. Defines the locales that alpha constrains to"
    },
    {
        name: "saveCursorPos",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If set to true will persist the position of the input cursor after update."
    },
    {
        name: "valueAlignment",
        type: "['left','center','right']",
        defaultValue: "left",
        isRequired: "false",
        description:
            "Determines the alignment of the input value. Supported values: left, center, right"
    },
    {
        name: "preventPaste",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description:
            "If set to true this property will prevent the user from pasting in the input field. In addition you have to provide a hint message to be displayed for the user to be notified that pasting is not allowed."
    },
    {
        name: "upperCase",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If set to true, it will display the value of the input in upper case."
    },
    {
        name: "inputRef",
        type: "func|object",
        defaultValue: "false",
        isRequired: "false",
        description:
            "Property to pass a ref callback (or an object using React.createRef()) to the native input component. Usecase: Focusing the inner input elemnt from outside the component."
    },
    {
        name: "autoGrow",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If set to true, it will make the input to grow/shrink with contents"
    },
    {
        name: "autoGrowInitialWidth",
        type: "Number",
        defaultValue: "30",
        isRequired: "infinite",
        description:
            "Defines the initial width in px for the input when autoGrow is true and no value or placeholder available to compute width of input"
    },
    {
        name: "autoGrowOffset",
        type: "Number",
        defaultValue: "15",
        isRequired: "infinite",
        description: "Defines the start offset width in px of the input when autoGrow: true"
    }
]);

export default documentedProperties;
